// extracted by mini-css-extract-plugin
module.exports = {"qr-sign_root":"QrSign_qr-sign_root__WfXPn","qr-sign_body":"QrSign_qr-sign_body__3uckv","qr-sign_qr":"QrSign_qr-sign_qr__2VE7m","qr-sign_text":"QrSign_qr-sign_text__S-ncM"};